import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, EventEmitter, Output, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faLeaf } from '@fortawesome/free-solid-svg-icons';

@Component({
  standalone: true,
  selector: 'cr-submit-btn',
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './creation-submit-btn.atom.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreationSubmitBtnAtom implements OnInit {
  @Output() btnClicked = new EventEmitter();
  @Input() submitText = 'Publish';
  @Input() active = true;
  @Input() faIcon: any;
  @Input() isHidden = false;
  @Input() disabled = false;
  constructor() {}

  ngOnInit(): void {}
}
